import { render, staticRenderFns } from "./ItTakesTwo.vue?vue&type=template&id=6e95aa82&lang=pug&"
import script from "./ItTakesTwo.vue?vue&type=script&lang=js&"
export * from "./ItTakesTwo.vue?vue&type=script&lang=js&"
import style0 from "../assets/themes/it-takes-two/scss/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports